/*
 * Model for working with Recommendations.
 */

define(["backbone", "moment", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Moment,
  Messenger,
  Properties,
) {
  var RecommendationsModel = {};

  RecommendationsModel.UpdateTopicSearch = Backbone.Model.extend({
    idAttribute: "fakeId",
    defaults: {
      fakeId: null,
    },
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      var url = Properties.rootURL + "/" + kbId + "/updateTopicSearch";
      return url;
    },
  });

  return RecommendationsModel;
});
